import React, { useState, useEffect } from 'react'
import styles from './match-animate.module.scss'

interface MatchAnimateProps {
  visible: boolean
  onAnimationComplete: () => void
  loop?: boolean // 是否循环播放
}

const MatchAnimate: React.FC<MatchAnimateProps> = ({ visible, onAnimationComplete, loop = false }) => {
  const [currentAnimation, setCurrentAnimation] = useState(2)
  const [isVisible, setIsVisible] = useState(true)
  const [isFading, setIsFading] = useState(false)

  useEffect(() => {
    if (visible) {
      setIsVisible(true)
      setCurrentAnimation(0)
      setIsFading(false)

      let animationCycle = () => {
        // 第一个动画：1秒
        const timer1 = setTimeout(() => {
          setIsFading(true)
          setTimeout(() => {
            setCurrentAnimation(1)
            setIsFading(false)
          }, 500) // 淡出500ms后切换动画
        }, 1000)

        // // 第二个动画：1秒
        // const timer2 = setTimeout(() => {
        //   setIsFading(true)
        //   setTimeout(() => {
        //     setCurrentAnimation(2)
        //     setIsFading(false)
        //   }, 500) // 淡出500ms后切换动画
        // }, 2000)

        // 第三个动画：1秒
        const timer3 = setTimeout(() => {
          setIsFading(true)
          setTimeout(() => {
            setCurrentAnimation(0) // 重新开始循环
            setIsFading(false)
          }, 500) // 淡出500ms后切换动画
        }, 3000)

        return [timer1, timer3]
      }

      const timers = animationCycle()

      // 如果不循环，在动画完成后触发回调
      if (!loop) {
        const timer4 = setTimeout(() => {
          onAnimationComplete()
        }, 4000)
        timers.push(timer4)
      }

      return () => {
        timers.forEach(timer => clearTimeout(timer))
      }
    } else {
      setIsVisible(false)
      setCurrentAnimation(0)
      setIsFading(false)
    }
  }, [visible, onAnimationComplete, loop])

  if (!isVisible) {
    return null
  }

  const getAnimationContent = () => {
    switch (currentAnimation) {
      case 0:
        return (
          <div className={styles['animation-container']}>
            <div className={`${styles['animation-content']} ${isFading ? styles['fade-out'] : styles['fade-in']}`}>
              <div className={styles['icon-container']}>
                <img src={require('@imgs/information/runing.png')} alt="loading" className={styles.runing} />
                <img src={require('@imgs/information/uploading.png')} alt="uploading" className={styles.uploading} />
              </div>
              <div className={styles.text}>资料审核中...</div>
              <div className={styles['sub-text']}>正在申请中，请勿退出</div>
            </div>
          </div>
        )
      case 1:
        return (
          <div className={styles['animation-container']}>
            <div className={`${styles['animation-content']} ${isFading ? styles['fade-out'] : styles['fade-in']}`}>
              <div className={styles['icon-container']}>
                <img src={require('@imgs/information/runing.png')} alt="loading" className={styles.runing} />
                <img src={require('@imgs/information/uploading.png')} alt="uploading" className={styles.uploading} />
              </div>
              <div className={styles.text}>机构匹配中...</div>
              <div className={styles['sub-text']}>正在申请中，请勿退出</div>
            </div>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className={styles['match-animate-overlay']}>
      {getAnimationContent()}
    </div>
  )
}

export default MatchAnimate
